import React from "react";
import {
  List,
  ListItem,
  IconButton,
  Flex,
  Button,
  Text,
} from "@chakra-ui/react";
import { AddIcon, EditIcon } from "@chakra-ui/icons";
import { useHistory } from "react-router-dom";
import { FormSelect } from "../FormSelect";
import "./style.scss";

export const DynoList = ({
  dynos,
  dynoStatuses = [],
  onDynoStatusChange,
  addDynoToClass,
  editDynoTitle,
  style,
}) => {
  const history = useHistory();
  return (
    <List style={style}>
      {React.Children.toArray(
        dynos.map((d) => (
          <ListItem className="dyno_item">
            <Flex
              style={{
                background: "#30918E",
                borderRadius: "20px",
                padding: "10px 10px",
                margin: "0 0 10px 0",
                color: "#fff",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Button
                variant="text"
                onClick={() => history.push(`/viewer/${d.id}`)}
              >
                {d.dynoTitle}
              </Button>
              <Flex
                style={{
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "70%",
                }}
              >
                {d?.status?.statusType !== "AddedToClass" ? (
                  <FormSelect
                    formProps={{ style: { maxWidth: "170px" } }}
                    padding={{ base: "0 0 0" }}
                    label=""
                    options={dynoStatuses.map((status) => ({
                      ...status,
                      value: status.id,
                    }))}
                    value={d?.status?.id}
                    disabled={d?.status?.statusType === "AddedToClass"}
                    placeholder="Select status"
                    selectOnChange={(e) =>
                      onDynoStatusChange(e.target.value, d.id)
                    }
                    name="grade"
                    isWorking={d.isWorking}
                  />
                ) : (
                  <Text
                    style={{
                      color: "#fff",
                      padding: "0 10px 0 0",
                      fontWeight: "500",
                    }}
                  >
                    Added to class
                  </Text>
                )}
                <Button
                  aria-label={`Add ${d.dynoTitle} to class`}
                  variant="outline"
                  style={{
                    margin: "0 10px 0",
                  }}
                  _hover={{
                    bg: "blue.500",
                  }}
                  onClick={() => editDynoTitle(d.id, d.dynoTitle)}
                >
                  Update title
                </Button>
                {d.status.statusType === "Published" && (
                  <Button
                    aria-label={`Add ${d.dynoTitle} to class`}
                    variant="outline"
                    style={{
                      margin: "0 10px 0 0",
                    }}
                    _hover={{
                      bg: "blue.500",
                    }}
                    onClick={() => addDynoToClass(d.id)}
                  >
                    <AddIcon fontSize="16px" marginRight="5px" /> Add to class
                  </Button>
                )}
                <IconButton
                  aria-label={`Edit ${d.dynoTitle}`}
                  icon={<EditIcon width="20px" height="20px" />}
                  style={{
                    padding: "0",
                    width: "20px",
                    background: "none",
                  }}
                  onClick={() => history.push(`/editor/${d.id}`)}
                />
              </Flex>
            </Flex>
          </ListItem>
        ))
      )}
    </List>
  );
};
